import React, {useContext} from 'react';
import stylesSample4 from './BusinessCardSample4.module.css'
import {observer} from "mobx-react-lite";
import styles from "../BusinessCard.module.css";
import {Context} from "../../../../../index";

const BusinessCardSample4 = observer(() => {
    const {businessCard} = useContext(Context);

    return (
        <div className={styles.businessCard}>
            <div id='businessCardContent'>
                <div className={`${stylesSample4.background} ${styles.padding}`}>
                    <div className={`${styles.content} ${stylesSample4.border}`}>
                        <div className={stylesSample4.mainInf}>
                            <div className={stylesSample4.name}>
                                {businessCard.name}
                            </div>
                            <div className={stylesSample4.jobTitle}>
                                {businessCard.jobTitle}
                            </div>
                        </div>
                        <div className={stylesSample4.informationBlock}>
                            <div className={stylesSample4.header}>
                                {businessCard.header}
                            </div>
                            <div>
                                {businessCard.phone}
                            </div>
                            <div>
                                {businessCard.email}
                            </div>
                            <div>
                                {businessCard.address}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default BusinessCardSample4;